import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ungroupDatabasesAction, DatabaseForUngrouping } from '../../../actions/spaces/UngroupDatabasesAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const UngroupDatabasesAction: IEntityAction<DatabaseForUngrouping, {}> = {
  name: EntityActionNames.UngroupDatabases,
  translateName: Messages.ungroupDatabases_action,
  isVisible: (items: DatabaseForUngrouping[], state) => {
    const featureEnabled =
        CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) &&
        FeatureFlags.mergeDedupeDatabasesEnabled &&
        selectCatalogingOnSiteEnabled(state);
    const hasUngroupedItems = items.some(item => !item.isGrouped);
    const hasGroupedItems = items.some(item => item.isGrouped);
    return featureEnabled && hasGroupedItems && !hasUngroupedItems;
  },
  isClickable: (_, items) => items.length === 1,
  createReduxAction: (items: DatabaseForUngrouping[]) => {
    return ungroupDatabasesAction(items[0]);
  }
};
